import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Modal from '~/components/Modal'
import { useSwitch } from '~/hooks'
import { ReactComponent as Q } from '../assets/q.svg'

export const PreviewWarning = () => {
  const { sw, on, off } = useSwitch(false)
  const { t } = useTranslation()
  return (
    <>
      <StyledWaring onClick={on}>
        {t('preview_warning')}
        <IconQ />
      </StyledWaring>
      <Modal isOpen={sw} onDismiss={off} contentClassName="lo-preview-warning">
        <StyledWarningContainer>
          <h2>{t('preview_warning_title')}</h2>
          <StyledWarningContent>
            <p>{t('preview_warning_content')}</p>
            <StyledWarningOptions>
              <li>
                <StyledDot />
                <span>{t('preview_warning_option_1')}</span>
              </li>
              <li>
                <StyledDot />
                <span>{t('preview_warning_option_2')}</span>
              </li>
              <li>
                <StyledDot />
                <span>{t('preview_warning_option_3')}</span>
              </li>
            </StyledWarningOptions>
          </StyledWarningContent>
          <button onClick={off}>{t('got_it')}</button>
        </StyledWarningContainer>
      </Modal>
    </>
  )
}

const IconQ = styled(Q)`
  margin-left: 7px;
  margin-right: 7px;
  margin-bottom: -1px;
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: -2.4px;
`

const StyledWaring = styled.div`
  position: relative;
  cursor: pointer;
  background: #efecff;
  border: 1px solid #eaecf6;
  border-radius: 12px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 8px 10px 8px 12px;
  font-size: 13px;
  line-height: 16px;
  line-height: 140%;
  color: #604dbc;
  vertical-align: middle;

  span {
    flex: 1;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 13%;
    border: 5px solid #efecff;
    transform: rotate(-45deg) translateY(50%);
  }
`
const StyledWarningContainer = styled.div`
  h2 {
    margin-bottom: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #191c1e;
  }

  button {
    cursor: pointer;
    text-align: center;
    width: 100%;
    background: #5f4dbc;
    border-radius: 48px;
    padding: 13px 0;
    border: none;
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;
    color: #ffffff;
  }
`

const StyledWarningContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  margin: 18px 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #191c1e;

  p {
    margin-bottom: 0;
  }
`

const StyledWarningOptions = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  gap: 8px;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;

  li {
    display: flex;
    gap: 8px;
  }
`

const StyledDot = styled.span`
  flex: none;
  display: inline-block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin-top: 6px;
  margin-left: 8px;
  background: #191c1e;
`
